import React from 'react';
import { SVGComponentProps } from 'modules/core/components/layout/svg/index';

export const PlainFlashSVG: React.FC<SVGComponentProps> = ({ className }: SVGComponentProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="13.469" height="24.542" viewBox="0 0 13.469 24.542" className={className}>
    <path d="M47.922,7.923H42.652L43.535.9a.422.422,0,0,0-.267-.441.4.4,0,0,0-.474.167l-6.41,11.683a.433.433,0,0,0-.008.423.4.4,0,0,0,.351.214h5.192l-.7,7.035a.421.421,0,0,0,.276.432.4.4,0,0,0,.469-.174l6.3-11.682C48.342,8.427,48.067,7.923,47.922,7.923Z" transform="translate(-35.563 0.338)"/>
  </svg>
);